import { apiAction } from './api';
export const SET_INCIDENTS = 'SET_INCIDENTS';
export const GET_INCIDENTS = 'GET_INCIDENTS';
import { setTasks } from './tasks';
import endpoints from './endpoints';

export const getIncidents = () => {
  return apiAction({
    url: endpoints.getIncidents,
    onSuccess: [setIncidents, setTasks],
    label: GET_INCIDENTS,
  });
};

const setIncidents = (data) => {
  return {
    type: SET_INCIDENTS,
    payload: data,
  };
};

export const incidents = (state = [], action) => {
  switch (action.type) {
    case SET_INCIDENTS:
      return action.payload.incidents;
    default:
      return state;
  }
};
